import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { trackPageView } from '../../analytics'
import { PageMeta } from '../seo/PageMeta'
import { JsonLd } from '../seo/JsonLd'
import { Navbar } from './Navbar'
import { Footer } from './Footer'
import { CustomCursor } from '../ui/CustomCursor'
import { GoToTop } from '../ui/GoToTop'
import { WhatsAppFloat } from '../ui/WhatsAppFloat'
import { ScrollToTop } from '../ui/ScrollToTop'

export function Layout() {
  const location = useLocation()
  useEffect(() => {
    trackPageView(location.pathname || '/', document.title)
  }, [location.pathname])
  return (
    <>
      <PageMeta />
      <JsonLd />
      <ScrollToTop />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-accent focus:text-navy-900 focus:rounded-2xl"
      >
        Skip to content
      </a>
      <CustomCursor />
      <Navbar />
      <main id="main" className="relative">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
      <WhatsAppFloat />
      <GoToTop />
    </>
  )
}
